module.exports = __webpack_public_path__ + "img/app8header.ddccbd0e.png";